// App.js

import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import NewCampaign from "./pages/NewCampaign";
import Login from "./pages/account/Login";
import Register from "./pages/account/Register";
import ChangePassword from "./pages/account/ChangePassword";
import UpdateUser from "./pages/account/Update_User";
import Recharge from "./pages/payment/Recharge";
import PrivacyPolicy from "./pages/footer_pages/PrivacyPolicy";
import TermsOfUse from "./pages/footer_pages/TermsOfUse";
import PaymentResult from "./pages/payment/PaymentResult";
import RefundPolicy from "./pages/footer_pages/RefundPolicy";
import ContactSupport from "./pages/footer_pages/ContactSupport";
import DownPage from "./pages/DownPage";
import "./App.css";

const isServiceDown = false; // 硬编码服务状态：true 表示进入维护模式，false 表示正常运行

const App = () => {
  const location = useLocation();
  const showFooter = [
    "/",
    "/privacy-policy",
    "/terms-of-use",
    "/refund-policy",
    "/contact-support",
  ].includes(location.pathname);

  return (
    <div id="root">
      {isServiceDown ? (
        <DownPage /> // 如果服务不可用，显示 DownPage
      ) : (
        <>
          <Navbar />
          <div className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/new_campaign" element={<NewCampaign />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/change_password" element={<ChangePassword />} />
              <Route path="/update_user" element={<UpdateUser />} />
              <Route path="/recharge" element={<Recharge />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/payment_result" element={<PaymentResult />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/contact-support" element={<ContactSupport />} />
              <Route path="/down" element={<DownPage />} />
            </Routes>
          </div>
          {showFooter && <Footer />}
        </>
      )}
    </div>
  );
};

const AppWrapper = () => {
  return (
    <Router>
      <App />
    </Router>
  );
};

export default AppWrapper;
